/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { sharedListPagesTabelStyle } from "@monsma/App/WidgetExtensions/MyAccount/MyAccountListPagesExtension";
import { rfqMyQuotesTableStyles } from "@monsma/Overrides/Widgets/RfqMyQuotes/RfqMyQuotesTable";
import { screen } from "@monsma/XDL/Helpers";
import { css } from "styled-components";

rfqMyQuotesTableStyles.wrapper = sharedListPagesTabelStyle.container;

rfqMyQuotesTableStyles.noResultsContainer = sharedListPagesTabelStyle.noResultsContainer;

rfqMyQuotesTableStyles.customerCell = {
    typographyProps: {
        ellipsis: true,
        css: css`
            display: block;
            max-width: 450px;
            ${screen("lte", "md")} {
                max-width: 200px;
            }
        `,
    },
};
rfqMyQuotesTableStyles.shipToCell = rfqMyQuotesTableStyles.customerCell;
